// extracted by mini-css-extract-plugin
export default {"menu":"TabSwitcher_menu__olNgG"};